import React from 'react';
import { Container, Row, Col } from 'bootstrap-4-react';
import portfolioHero from "../../images/portfolio-hero.jpg";
import sample from "../../images/portfolio/mtn-inside.png";
import Slide from 'react-reveal/Slide';
import HeroSection from '../../Components/HeroSection/HeroSection';
import Header from '../../Header/Header';
import "../PortfolioPage.css";
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Footer from '../../Footer/Footer';
import ReactGA from 'react-ga';
class PortfolioProduct extends React.Component {
    componentDidMount() {
        ReactGA.pageview('/infosport/');
    }
    render() {
        window.scrollTo(0, 0);
        return (
            <div className="portfolio-page">
                <Header />
                <HeroSection pageTitle="Case Studies" background={portfolioHero} />
                <section className='single-portfolio'>
                    <Container>
                        <Row>
                            <Col col="md-4 12" offset="md-1" className="project-image no-height">
                                <img width="100%" src={sample}/>
                            </Col>
                            <Col col="md-7 12" className="text-left">
                                <h1>MTN info sport</h1>
                                <p className="project-description">
                                Moobifun has partnered with a leading sports content provider, to offer mobile operators Infosport service (exclusive sports news to customers on a subscription basis). We have created flexible payment operations with fees payable on a daily, weekly or monthly basis. The premium features include: breaking news, live goal alerts, live scores, league positions;
                                all of which are filterable by the customer’s favourite sports and team. We provide this service in the Ivory Coast, Congo and Senegal through MTN and TIGO.
                                </p>
                                <div className="info-project">
                                    <span className="info">
                                        <i className="fa fa-map-marker"></i>
                                        <span> Côte D'ivoire, Guinée Conakry, Sénégal, Rwanda, Cameroon and Congo.</span>
                                    </span>
                                    <span className="info">
                                        <i className="fa fa-calendar"></i>
                                        <span>2014</span>
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <Footer/>
            </div>
        );
    }
}
export default PortfolioProduct;
